import {StateLabel, type StateLabelProps} from '@primer/react'
import {useMemo} from 'react'
import {clsx} from 'clsx'
import styles from './PullRequestStateLabel.module.css'
import {STATE_LABEL_DATA, type PullRequestState as PullRequestStateType, PullRequestState} from '../types'

interface PullRequestStateLabelProps {
  className?: string
  state: PullRequestStateType
}

export function PullRequestStateLabel({className, state}: PullRequestStateLabelProps) {
  const stateLabel = useMemo(() => STATE_LABEL_DATA[state], [state])

  // TODO: Remove after Primer is updated with unlisted state
  // also clean up tests: ../__tests__/PullRequestStateLabel.test.tsx
  // see: https://github.com/github/pull-requests/issues/19319
  if (state === PullRequestState.Unlisted) {
    return (
      <span className={styles.unlisted}>
        <GitPullRequestUnlistedSvg /> Unlisted
      </span>
    )
  }

  return (
    <StateLabel className={clsx('flex-self-start', className)} status={stateLabel.status as StateLabelProps['status']}>
      {stateLabel.description}
    </StateLabel>
  )
}

// TODO: Upstream to Primer, see: https://github.com/github/pull-requests/issues/19319
function GitPullRequestUnlistedSvg() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3.25C2.5 2.83579 2.83579 2.5 3.25 2.5C3.66421 2.5 4 2.83579 4 3.25C4 3.66421 3.66421 4 3.25 4C2.83579 4 2.5 3.66421 2.5 3.25ZM3.25 1C2.00736 1 1 2.00736 1 3.25C1 4.22966 1.62611 5.06309 2.5 5.37197V10.628C1.62611 10.9369 1 11.7703 1 12.75C1 13.9926 2.00736 15 3.25 15C4.49264 15 5.5 13.9926 5.5 12.75C5.5 11.7703 4.87389 10.9369 4 10.628V5.37197C4.87389 5.06309 5.5 4.22966 5.5 3.25C5.5 2.00736 4.49264 1 3.25 1ZM3.25 12C2.83579 12 2.5 12.3358 2.5 12.75C2.5 13.1642 2.83579 13.5 3.25 13.5C3.66421 13.5 4 13.1642 4 12.75C4 12.3358 3.66421 12 3.25 12Z"
      />
      <path d="M14 7.5C14 8.19036 13.3844 8.75 12.625 8.75C11.8656 8.75 11.25 8.19036 11.25 7.5C11.25 6.80964 11.8656 6.25 12.625 6.25C13.3844 6.25 14 6.80964 14 7.5Z" />
      <path d="M14 2.75C14 3.44036 13.3844 4 12.625 4C11.8656 4 11.25 3.44036 11.25 2.75C11.25 2.05964 11.8656 1.5 12.625 1.5C13.3844 1.5 14 2.05964 14 2.75Z" />
      <path d="M10.2197 10.7197C10.5126 10.4268 10.9874 10.4268 11.2803 10.7197L14.2803 13.7197C14.5732 14.0126 14.5732 14.4874 14.2803 14.7803C13.9874 15.0732 13.5126 15.0732 13.2197 14.7803L10.2197 11.7803C9.92683 11.4874 9.92683 11.0126 10.2197 10.7197Z" />
    </svg>
  )
}

try{ PullRequestStateLabel.displayName ||= 'PullRequestStateLabel' } catch {}
try{ GitPullRequestUnlistedSvg.displayName ||= 'GitPullRequestUnlistedSvg' } catch {}